export enum SystemFileEnums {
    SystemLogs = "SystemLogs",
    SystemDbs = "SystemDbs",
}
